import styled from 'styled-components'

const button = styled.div`
  padding: 10px;
  background-color: #5352ed;
  color: white;
  font-size: 28px;
  border-radius: 15px;
  box-sizing: border-box;
  cursor: pointer;
  &:hover {
    background-color: #3742fa;
    width: 100%;
  }
`

export default button
